import PropTypes from 'prop-types';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import ClickableDropdown from '../../clickableDropdown';
import SimpleButton from './SimpleButton';

export default function ButtonWrapper(props) {
    let label = null;
    if (props.label) {
        label = props.label;
    } else if (!props.domainSettings) {
        label = 'View Details';
    }

    if (isEmpty(props.url)) {
        return null;
    }
    if (typeof props.url === 'string') {
        const action = props.getUrlAction(props.url);

        return <SimpleButton label={label} action={action} />;
    }
    const options = props.url.map((singleUrlMeta) => ({
        title: singleUrlMeta.name,
        onClick: props.getUrlAction(singleUrlMeta.url),
    }));

    return (
        <ClickableDropdown
            className={props.className}
            buttonName={label}
            options={options}
            isOpen={props.dropdownData.isOpen}
            onClick={props.dropdownData.onClick}
        />
    );
}

ButtonWrapper.propTypes = {
    className: PropTypes.string,
    isAdmin: PropTypes.bool.isRequired,
    actsAsAdmin: PropTypes.bool.isRequired,
    getUrlAction: PropTypes.func.isRequired,
    url: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.array.isRequired]),
    label: PropTypes.string,
    dropdownData: PropTypes.shape({
        isOpen: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
    }),
    domainSettings: PropTypes.string,
};
